module.exports = __webpack_public_path__ + "static/img/chakanjietu.2a5032c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/chakanjietu.png
// module id = /HC6
// module chunks = 24